module.exports = __webpack_public_path__ + "static/logo-9d3576a74119a9304b92cb06cc0b2ec5.png";